/**
 * 会员提问请求接口
 * @author 王振宇
 * @since 2022-06-07
 */
export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request,
    serviceForMock = _ref.serviceForMock,
    requestForMock = _ref.requestForMock,
    mock = _ref.mock,
    faker = _ref.faker,
    tools = _ref.tools;
  return {
    GET_MEMBERASKQUESTIONS_PAGE_LIST: function GET_MEMBERASKQUESTIONS_PAGE_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/memberAskQuestions/getPageList',
        method: 'get',
        params: data
      });
    },
    GET_MEMBERASKQUESTIONS_LIST: function GET_MEMBERASKQUESTIONS_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/memberAskQuestions/getList',
        method: 'get',
        params: data
      });
    },
    GET_MEMBERASKQUESTIONS_INFO: function GET_MEMBERASKQUESTIONS_INFO() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/memberAskQuestions/info',
        method: 'get',
        params: data
      });
    },
    SAVE_MEMBERASKQUESTIONS: function SAVE_MEMBERASKQUESTIONS() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/memberAskQuestions/save',
        method: 'post',
        data: data
      });
    },
    UPDATE_MEMBERASKQUESTIONS: function UPDATE_MEMBERASKQUESTIONS() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/memberAskQuestions/update',
        method: 'put',
        data: data
      });
    },
    DELETE_MEMBERASKQUESTIONS: function DELETE_MEMBERASKQUESTIONS() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/memberAskQuestions/delete',
        method: 'delete',
        data: data
      });
    },
    DELETE_BATCH_MEMBERASKQUESTIONS: function DELETE_BATCH_MEMBERASKQUESTIONS() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/memberAskQuestions/deleteBatch',
        method: 'delete',
        data: data
      });
    }
  };
});